import { React, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';

import FetchModule from '../../../../Share/Network/FetchModule';
import { useLanguage } from '../../../../../Context/LanguageContext';

const MemberShipDeleteModal = (props) => {
  const { data, index, className, exitClickFn, rendering } = props;

  const history = useHistory();
  const { t } = useLanguage();

  useEffect(() => {
    // document.body.style.cssText = `position: fixed; top: -${window.scrollY}px`

    // return () => {
    //   const scrollY = document.body.style.top;
    //   document.body.style.cssText = `position: ""; top: "";`
    //   window.scrollTo(0, parseInt(scrollY || '0') * -1)
    // }
    document.body.style= `overflow: hidden`;
    return () => document.body.style = `overflow: auto`
  }, [])

  function exitClick() {
    exitClickFn(className);
  }

  function deleteClick() {
    // const fetchModule = new FetchModule();
    // (
    //   async () => {
    //     const responseData = await fetchModule.deleteData('membership/usage/delete/' + data[index].usageId, 'DELETE');
       
    //     if (responseData.status === 200) {
    //       alert('회원권을 삭제하였습니다.');
    //       exitClickFn(className);
    //       rendering();
    //     }
    //     else if (responseData.status === 401) {
    //       alert('로그인 후 다시시도하세요');
    //       history.push('/');
    //     }
    //   }
    // )();
    let requestData = {
      usageId: data[index].usageId
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('membership/usage/delete/', 'POST', requestData);
       
        if (responseData.status === 200) {
          alert(t('memberDetail.alertMembershipDeleted'));
          exitClickFn(className);
          rendering();
        }
        else if (responseData.status === 401) {
          alert(t('memberDetail.alertLoginRetry'));
          history.push('/');
        }
        else {
          alert(responseData.error);
          return;
        }
      }
    )();
  }

  return (
    <TopLevelWrapper>
      <ModalView>
        <TotalWrapper>
          <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#232323' cursor='default'>{t('memberDetail.membershipDeleteTitle')}</Text>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#777777' cursor='default'>{t('memberDetail.membershipDeleteDesc1')}</Text>
          <TextWrapper>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='default'>{t('memberDetail.membershipDeleteDesc2')}</Text>
            <ExplanationWrapper>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='default'>{t('memberDetail.membershipDeleteLinkoPay1')}</Text>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#D92828' cursor='default'>{t('memberDetail.membershipDeleteLinkoPay2')}</Text>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='default'>{t('memberDetail.membershipDeleteLinkoPay3')}</Text>
            </ExplanationWrapper>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='default'>{t('memberDetail.membershipDeleteConfirm')}</Text>
          </TextWrapper>
          <ButtonWrapper>
            <ExitButton onClick={exitClick}>{t('memberDetail.modalCancel')}</ExitButton>
            <DeleteButton onClick={deleteClick}>{t('memberDetail.modalDeleteBtn')}</DeleteButton>
          </ButtonWrapper>
        </TotalWrapper>
      </ModalView>
    </TopLevelWrapper> 
  )
}

export default MemberShipDeleteModal;

const startAnimation = keyframes`
	0% { opacity: 0; }
	50% { opacity: 0.5; }
	100% { opacity: 1; }
`;

const TopLevelWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;

  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  justify-content: center;
  align-items: center;

  z-index: 1000;

  width: 100vw;
  height: 100vh;

  background-color: rgba(0, 0, 0, 0.2);
	
	animation-name: ${startAnimation};
	animation-duration: 0.5s;
	animation-timing-function: ease-out;
`;

const ModalView = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 425px;
  height: 248px;

  border-radius: 10px;
  box-shadow: 0px 40px 50px rgba(0, 0, 0, 0.1);
  background-color: #FFFFFF;
`;

const TotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 385px;
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: #232323;

  // margin: 0 0 13px 28px;
  margin: 0 0 0 0;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  
  justify-content: flex-start;
  align-items: flex-end;

  margin-top: 30px;

  width: 100%;
`;

const ExplanationWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  gap 4px;
`;

const ColorExplanation = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #FF3131;
  
  margin: 0 0 0 0;
`;

const Explanation = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #595959;
  
  margin: 0 0 0 0;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  margin-top: 30px;

  width: 100%;

  gap: 10px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 62px;
  height: 40px;

  border-radius: 10px;
  background-color: #F5F6F8;
  
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #3E4148;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const DeleteButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100px;
  height: 40px;

  border-radius: 10px;
  background-color: #D92828;

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #FFFFFF;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;